export const FfZoomIn = () => (
  <>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_5_523)">
        <path
          d="M7.21875 14.4375C8.96191 14.4375 10.5627 13.816 11.8116 12.7837L13.1216 14.0938L12.5764 14.6389C12.308 14.9074 12.308 15.3426 12.5764 15.6111L18.7639 21.7986C18.8983 21.933 19.074 22 19.25 22C19.426 22 19.6017 21.933 19.7361 21.7986L21.7986 19.7361C22.067 19.4676 22.067 19.0324 21.7986 18.7639L15.6111 12.5764C15.3426 12.308 14.9074 12.308 14.6389 12.5764L14.0938 13.1216L12.7837 11.8116C13.816 10.5627 14.4375 8.96191 14.4375 7.21875C14.4375 3.23813 11.199 0 7.21875 0C3.23847 0 0 3.23813 0 7.21875C0 11.1994 3.23847 14.4375 7.21875 14.4375ZM20.3404 19.25L19.25 20.34L14.0346 15.125L15.125 14.035L20.3404 19.25ZM7.21875 1.375C10.4411 1.375 13.0625 3.99644 13.0625 7.21875C13.0625 10.4411 10.4411 13.0625 7.21875 13.0625C3.99644 13.0625 1.375 10.4411 1.375 7.21875C1.375 3.99644 3.99644 1.375 7.21875 1.375Z"
          fill="black"
        />
        <path
          d="M4.125 7.90625H6.53125V10.3125C6.53125 10.692 6.83925 11 7.21875 11C7.59825 11 7.90625 10.692 7.90625 10.3125V7.90625H10.3125C10.692 7.90625 11 7.59825 11 7.21875C11 6.83925 10.692 6.53125 10.3125 6.53125H7.90625V4.125C7.90625 3.7455 7.59825 3.4375 7.21875 3.4375C6.83925 3.4375 6.53125 3.7455 6.53125 4.125V6.53125H4.125C3.7455 6.53125 3.4375 6.83925 3.4375 7.21875C3.4375 7.59825 3.7455 7.90625 4.125 7.90625Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_523">
          <rect width="22" height="22" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);
